/* eslint-disable no-unused-vars */
import { axiosPublic, axiosPrivate, getSequencer } from ".";

export const getSales = params =>
  axiosPrivate.post(
    "vendas",
    {
      sequencial: getSequencer(),
      ...params,
    },
    { cache: true, responseType: params.exportation ? "arraybuffer" : "json" }
  );

export const getDiscountCoupons = (store, couponCode, initialDate, finalDate) =>
  axiosPrivate.post(
    "loja/cupom/listar",
    {
      loja: store,
      codigo: couponCode,
      dthr_validade_ini: initialDate,
      dthr_validade_fim: finalDate,
    },
    { cache: true }
  );

export const getCouponById = couponId =>
  axiosPrivate.get(`loja/cupom/id/${couponId}`, {
    cache: true,
  });

export const registerDiscountCoupon = coupon =>
  axiosPrivate.post("loja/cupom/cadastro", coupon, { cache: true });

export const updateDiscountCoupon = coupon =>
  axiosPrivate.post("loja/cupom/alterar", coupon, { cache: true });

export const deleteDiscountCoupon = couponId =>
  axiosPrivate.delete(
    `loja/cupom/deletar/${couponId}`,
    {
      id: couponId,
    },
    { cache: true }
  );

export const getTicketPackages = (producerId, params) =>
  axiosPrivate.post(
    "pacotes",
    {
      loja: producerId,
      ...params,
    },
    { cache: true }
  );

export const cancelTicket = (
  loja,
  iditem,
  idpedido_marketplace,
  ano_mes,
  motivo_cancelamento,
  idconsumidor
) =>
  axiosPrivate.post(
    `marketplace/pedido/cancelar/item/${iditem}`,
    {
      loja: loja,
      idpedido_marketplace: idpedido_marketplace,
      ano_mes: ano_mes,
      motivo_cancelamento: motivo_cancelamento,
      idconsumidor: idconsumidor,
    },
    { cache: true }
  );
